/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import './swiper-pagination.scss';

const SwiperPagination = ({ swiperRef, hasDots = true, hasArrows = true }) => {
  return (
    <div className="pagination-container-component">
      {hasDots && <div className="swiper-pagination"></div>}

      {hasArrows && (
        <div className="arrows-slider">
          <button className="left-arrow" alt="Bold" onClick={() => swiperRef.current.swiper.slidePrev()} type="button">
            <div></div>
          </button>
          <button className="right-arrow" alt="Bold" onClick={() => swiperRef.current.swiper.slideNext()} type="button">
            <div></div>
          </button>
        </div>
      )}
    </div>
  );
};

export default SwiperPagination;
